module.exports = __webpack_public_path__ + "static/media/logodatalife_app_login.f292e8e9.svg";